var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{ref:"audio",attrs:{"src":require("@/assets/y1197.mp3")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }